// app-src-react/index.js
import './Megatron';
import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './app';
import { BrowserRouter } from "react-router-dom";
import AppProvider from './app/provider';



const rootElement = document.getElementById('root');
const root = createRoot(rootElement);

root.render(
  <BrowserRouter>
    <AppProvider>
      <App />
    </AppProvider>
  </BrowserRouter>
);